module.exports = __webpack_public_path__ + "static/img/zhutu装载机.1024a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/zhutu装载机.png
// module id = AWPX
// module chunks = 0